'use client';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/react-ui';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';

import { SingleMatch } from '@/modules/league/new-components/change-scores-components/SingleMatch';
import { CompletedMatch, GameDayInfo } from '@/modules/league/new-components/types';
import { useLoader } from '@/modules/league/PickleballLoaderContext';

interface ChangeScoresWrapperProps {
  params: { slug: string; sessionId: string; matchDateId: string };
  headerContent: GameDayInfo;
  completedMatches: CompletedMatch[];
  isAuthorized: boolean | null;
}

const AllMatches = ({
  params,
  headerContent,
  completedMatches,
  isAuthorized,
}: ChangeScoresWrapperProps) => {
  const { setLoading } = useLoader();
  const { slug, sessionId, matchDateId } = params;

  return (
    <div className='mx-auto w-full p-2 md:px-3 lg:px-3'>
      <Button
        variant='link-gray'
        className='!md:text-sm rounded-md border border-gray-300 !bg-white !p-1 !text-xs font-semibold tracking-wider !text-leagues-500/90 shadow-xs hover:!text-leagues-700'
        onClick={() => {
          setLoading(true);
        }}
      >
        <CustomLink
          href={`${process.env.NEXT_PUBLIC_PL_URL}/leagues/${slug}/session/${sessionId}/matchdate/${matchDateId}?tab=matches`}
          className='p-1'
        >
          <FontAwesomeIcon icon={faArrowLeft} className='mr-2' />
          Back to game day
        </CustomLink>
      </Button>

      <div className='flex flex-col gap-2'>
        <div className='items-left justify-left flex pt-2 text-sm text-error-600'>
          This league format allows you to update matches below although will not update standings.
        </div>
        <div className='items-left justify-left flex text-sm text-error-600'>
          Any match older then 90 will not impact rating changes.
        </div>
      </div>

      <div className='grid grid-cols-1 gap-2 py-2 md:grid-cols-2 md:gap-4 md:p-0 md:py-2 lg:grid-cols-3 lg:gap-6'>
        {completedMatches.map((match, i) => {
          return (
            <SingleMatch
              key={`completed-match-${i}`}
              headerContent={headerContent}
              match={match}
              isAuthorized={isAuthorized}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AllMatches;
